import {TextField} from "@mui/material";
import React from "react";

export function Form_Time(props) {
    const {item, localFormState, setLocalFormState} = props;
    const { inputSize = "normal" } = item;
    return (<>
        <TextField
            className={"w-100"}
            id="date"
            label={item.label}
            helperText={item.helperText}
            type="time"
            size={inputSize}
            // defaultValue=""
            sx={{width: 220}}
            InputLabelProps={{
                shrink: true,
            }}
            variant="outlined"
            // may need to change the value for this one.
            value={(localFormState[item.key] === null || localFormState[item.key] === undefined) ? '' : localFormState[item.key]}
            // value={
            //     (localFormState[item.key] === null || localFormState[item.key] === undefined) ? '':
            //         new Date(localFormState[item.key]).format("hh:mm:ss")
            // }
            onChange={
                (e) => {
                    // submit new state to the upper system
                    setLocalFormState({
                        ...localFormState,
                        [item.key]: e.target.value
                    });
                }
            }
        />
    </>);
}